import {
  GET_CHATBOT_RESPONSE_REQUEST,
  GET_CHATBOT_RESPONSE_SUCCESS,
  GET_CHATBOT_RESPONSE_FAILURE,
  CLEAR_CHATBOT_HISTORY
} from '../actionTypes';

export const getChatbotResponse = payload => ({
  type: GET_CHATBOT_RESPONSE_REQUEST,
  payload
});

export const getChatbotResponseSuccess = payload => ({
  type: GET_CHATBOT_RESPONSE_SUCCESS,
  payload
});

export const getChatbotResponseFailure = payload => ({
  type: GET_CHATBOT_RESPONSE_FAILURE,
  payload
});

export const clearChatbotHistory = () => ({
  type: CLEAR_CHATBOT_HISTORY
});
